<template>
  <div>
    <nav
      class="level is-mobile is-dark"
      style="max-width: 400px; margin: 0 auto; max-height: 36px;"
    >
      <div class="level-left">
        <div class="level-item">
          <a :href="currentUrl" class="has-text-white">#{{roomId}}</a>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div v-if="user && user.username">
            {{user.username}} - {{user.wins}}
            <span v-if="user && user.wins != 1">wins</span>
            <span v-else>win</span>
          </div>
        </div>
        <div class="level-item">
          <div class="dropdown is-dark is-right is-hoverable">
            <div class="dropdown-trigger">
              <button
                class="button is-rounded is-small is-dark"
                aria-haspopup="true"
                aria-controls="dropdown-menu4"
              >
                <span class="icon is-small">
                  <i class="fas fa-angle-down" aria-hidden="true"></i>
                </span>
              </button>
            </div>
            <div class="dropdown-menu" id="dropdown-menu4" role="menu">
              <div class="dropdown-content">
                <div class="dropdown-item" v-on:click="showLeaderModal()">Leaderboard</div>
                <hr class="dropdown-divider" />
                <div class="dropdown-item" v-on:click="show(1)">Leave Room</div>
                <div v-if="room && room.state == 1 && user && user.position > -1">
                  <hr class="dropdown-divider" />
                  <div class="dropdown-item" v-on:click="show(5)">Start Game</div>
                </div>
                <div v-if="room && room.state == 3">
                  <hr class="dropdown-divider" />
                  <div class="dropdown-item" v-on:click="show(2)">Restart Game</div>
                  <hr class="dropdown-divider" />
                  <div class="dropdown-item" v-on:click="show(3)">End Game</div>
                  <hr class="dropdown-divider" />
                  <div class="dropdown-item" v-on:click="show(4)">Claim Game</div>
                </div>
                <div v-if="room && room.state >= 2">
                  <hr class="dropdown-divider" />
                  <div class="dropdown-item" v-on:click="showEmojiModal()">Send Emoji</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="modal" v-bind:class="{'is-active': showModal}">
      <div class="modal-background"></div>
      <div class="card" style="width: 300px; border-radius: 5px;">
        <div class="card-content is-size-6">
          <p v-if="mode == 4 && !user.canClaim">You cannot claim the game.</p>
          <p v-else>
            Are you sure you want to
            <span v-if="mode == 1">&nbsp;leave the room ?</span>
            <span v-if="mode == 2">&nbsp;restart the game ?</span>
            <span v-if="mode == 3">&nbsp;end the game ?</span>
            <span v-if="mode == 4 && user.canClaim">&nbsp;claim the game ?</span>
            <span v-if="mode == 5">&nbsp;start the game ? This will add AI Users.</span>
          </p>
        </div>
        <footer class="card-footer">
          <p class="card-footer-item" v-on:click="cancel()">Cancel</p>
          <p class="card-footer-item" v-on:click="ok()">OK</p>
        </footer>
      </div>
    </div>
    <div class="modal" v-bind:class="{'is-active': showLeaderboard}">
      <div class="modal-background"></div>
      <div class="card" style="width: 300px; border-radius: 5px;">
        <div class="card-content is-size-6">
          <LeaderboardComponent v-bind:room="room"></LeaderboardComponent>
        </div>
        <footer class="card-footer">
          <p class="card-footer-item" v-on:click="showLeaderboard = false">OK</p>
        </footer>
      </div>
    </div>
    <div class="modal" v-bind:class="{'is-active': showEmoji}">
      <div class="modal-background"></div>
      <EmojiComponent v-on:close-emoji="showEmoji = false"></EmojiComponent>
    </div>
  </div>
</template>

<script>
import socketStore from "@/service/socketStore";
import LeaderboardComponent from "@/components/LeaderboardComponent.vue";
import EmojiComponent from "@/components/EmojiComponent.vue";

export default {
  name: "TopNavComponent",
  components: {
    LeaderboardComponent,
    EmojiComponent,
  },
  props: {
    user: Object,
    room: Object,
    roomId: String,
  },
  data: function () {
    return {
      currentUrl: window.location.href,
      showModal: false,
      showLeaderboard: false,
      showEmoji: false,
      mode: 0,
    };
  },
  methods: {
    show(mode) {
      this.mode = mode;
      this.showModal = true;
      if (mode == 4) {
        this.checkClaim();
      }
    },
    showLeaderModal() {
      this.showLeaderboard = true;
    },
    showEmojiModal() {
      this.showEmoji = true;
    },
    checkClaim() {
      socketStore.emit("check_claim", "");
    },
    cancel() {
      this.showModal = false;
      this.mode = 0;
    },
    ok() {
      if (this.mode == 1) {
        socketStore.emit("leave_room", "");
        this.$router.push({ path: `/` });
      } else if (this.mode == 2) {
        socketStore.emit("restart_game", "");
      } else if (this.mode == 3) {
        socketStore.emit("end_game", "");
      } else if (this.mode == 4 && this.user.canClaim) {
        socketStore.emit("claim_game", "");
      } else if (this.mode == 5) {
        socketStore.emit("start_game", "");
      }
      this.mode = 0;
      this.showModal = false;
    },
  },
};
</script>

<style>
</style>